import { Regions } from "@/Enums";

export const getPlatform = () => {
  const isDevelopment = process.env.REACT_APP_ENV?.includes("development");
  const devDeployment = process.env.REACT_APP_DEPLOYMENT;
  const isElectron = !!window.electronAPI;
  const monolithDomain = window.location.origin;

  // check if the current domain is one of our known regions
  // if not, then the app is running in a non-monolith-cloud environment
  const region = Regions.find((r) => r.monolithDomain === monolithDomain) || {
    name: "On-Premises",
    monolithDomain: window.location.origin,
    relayDomain: window.location.origin + "/forensic-requests",
  };

  let isOnPremises = region.name === "On-Premises";

  if (isDevelopment) {
    isOnPremises = devDeployment === "onprem" ? true : false;
  }

  return {
    isOnPremises,
    isElectron,
    region: region.name,
    monolithDomain: region.monolithDomain,
    relayDomain: region.relayDomain,
    apiUrl: region.monolithDomain + "/api",
    isDevelopment,
    devDeployment,
  };
};

const usePlatform = () => {
  const platform = getPlatform();

  return platform;
};

export default usePlatform;
